"use strict";

import Vue from "vue";
import axios from "axios";
// import store from "@/store";

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL =
  process.env.baseURL ||
  process.env.apiUrl ||
  "https://www.lannapoly.ac.th/api/index.php?url=regisPersonal2/";
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: axios.defaults.baseURL //process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // store.state.showLoading = true;
    // console.log('Axios IN Request');
    return config;
  },
  function(error) {
    // Do something with request error
    // store.state.showLoading = false;
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    // store.state.showLoading = true;
    // console.log('Axios IN response');
    return response;
  },
  function(error) {
    // Do something with response error
    // store.state.showLoading = false;
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
